import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _AgreementClassification, _RecordType } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { FormforGroupSelect } from "../../../bpm/config/Componentes/FormforGroupSelect";
import { SelectorTypeForm } from "../../../bpm/config/Componentes/SelectorTypeForm";






export const RecordType = () => {

    const recordtype = useDataBean(_RecordType);
    const [GroupCode, setGroupCode] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [])


    const getLista = () => {

        recordtype.instance.getRecordTypeCatalogPorPropiedades({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        recordtype.setBean({
            State: 1,
            Since: single.getCurrenDate()
        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        recordtype.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        recordtype.bean.State = 2;
        //console.log(Project.bean);
        editaItem();

    }




    const head = [
        { title: 'ID', property: 'IDRecordType', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Código', property: 'CodeRecord', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Diccionario de datos', property: 'Diccionary', visible: true },
        // { title: 'Grupo de Formulario', property: 'GroupCode', visible: true },
        { title: 'Formualrio', property: 'IDFormType', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipo de Expediente">
            <div className="row">

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={recordtype.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">


                                <div className="col-md-12">
                                    <label>Nombre</label>
                                    <input type="text" className="form-control" name="Name" value={recordtype.bean.Name} onChange={recordtype.handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label>Código</label>
                                    <input type="text" className="form-control" name="CodeRecord" value={recordtype.bean.CodeRecord} onChange={recordtype.handleChange} />

                                </div>
                                <div className="col-md-6">
                                    <label>Diccionario de datos</label>
                                    <input type="text" className="form-control" name="Diccionary" value={recordtype.bean.Diccionary} onChange={recordtype.handleChange} />

                                </div>
                                {/* <div className="col-md-6">
                                    <SelectorTypeForm value={GroupCode} onChange={(e) => { setGroupCode(e) }} />
                                </div>
                                <div className="col-md-6">
                                    <FormforGroupSelect IDGrouspSelect={GroupCode} idSelector={recordtype.bean.IDFormType} onChange={(e: any) => { recordtype.setBean({ ...recordtype.bean, "IDFormType": e }) }} />
                                </div> */}
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={recordtype.bean.Description} onChange={recordtype.handleChange} />
                                </div>

                            </div>

                        </>
                    </Modal>


                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}